import { render, staticRenderFns } from "./UserAgreement.vue?vue&type=template&id=7332c97d&scoped=true"
import script from "./UserAgreement.vue?vue&type=script&lang=js"
export * from "./UserAgreement.vue?vue&type=script&lang=js"
import style0 from "./UserAgreement.vue?vue&type=style&index=0&id=7332c97d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7332c97d",
  null
  
)

export default component.exports